<template>
  <div class="container" v-if="calendarevents.length > 0">
    <h1>Kursplan</h1>
    <table class="table d-none d-sm-none d-md-block">
      <thead class="tableheadweek">
        <tr>
          <th width="60px">Zeit</th>
          <th width="12%" v-for="day1 in days" :id="'day' + day1">
            <h2>{{ new Date(day1).formatDate('dd') }}</h2>
          </th>
        </tr>
      </thead>
      <tbody name="table-row" class="calendarbody scrollabletable">
        <tr v-for="time in timeslots" class="timeslotcompact" :data-time="time" v-bind:style="{ height: (100 / timeslots.length) + '%' }">
          <td data-area="agenda">
            <p>{{ time.starttime }} - {{ time.endtime }}</p>
          </td>
          <td class="column" data-area="column" v-for="day in days" :data-date="day" :data-time=time style="padding:0px">
            <div v-for="slot in geteventsoftimeslot(day,time.starttime,time.endtime)">
              <div class="card" style="border-radius: 0; border: 0; margin-bottom: 2px" v-bind:style="{ 'background-color': getservicedata(slot.serviceid).color }">
                <div class="card-body">
                  <h5 class="card-title" style="font-size: 0.875rem;">{{ getservicedata(slot.serviceid).description }}</h5>
                  <p class="card-text" style="font-size: 9px;">{{ gettimeformat(slot.datestart) }} - {{ gettimeformat(slot.dateend) }}</p>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-block d-md-none">
      <div class="row" v-for="day1 in days" v-if="geteventsofday(day1).length > 0">
        <table class="table">
          <thead class="tableheadweek">
            <th width="10%">Zeit</th>
            <th width="90%"><h2>{{ new Date(day1).formatDate('dd') }}</h2></th>
          </thead>
          <tbody name="table-row" class="calendarbody scrollabletable">
            <tr v-for="time in timeslots" class="timeslotcompact" :data-time="time">
              <td data-area="agenda">
                <p>{{ time.starttime }} - {{ time.endtime }}</p>
              </td>
              <td class="column" data-area="column" :data-date="day1" :data-time=time style="padding:0px">
                <div v-for="slot in geteventsoftimeslot(day1,time.starttime,time.endtime)">
                  <div class="card" style="border-radius: 0; border: 0; margin-bottom: 2px" v-bind:style="{ 'background-color': getservicedata(slot.serviceid).color }">
                    <div class="card-body">
                      <h5 class="card-title" style="font-size: 0.875rem;">{{ getservicedata(slot.serviceid).description }}</h5>
                      <p class="card-text" style="font-size: 9px;">{{ gettimeformat(slot.datestart) }} - {{ gettimeformat(slot.dateend) }}</p>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'calendar',
  props: {
    companyid: String,
    companyid: String,
    definedlocations: '',
    definedservices: '',
  },
  data () {
    return {
      uri: '',
      calendarevents: [],
      companyservices: [],
      firstday: new Date(),
      lastday: new Date(),
      days: [],
      timeslots: [
        { name: 'Vor&shy;mittag', starttime: '6:00', endtime: '11:59' },
        { name: 'Nach&shy;mittag', starttime: '12:00', endtime: '17:59' },
        { name: 'Abends', starttime: '18:00', endtime: '23:00' }
      ]
    }
  },
  created: function () {
    if (process.env.NODE_ENV === 'development') {
      this.uri = '/calendarrequest'
    } else if (process.env.NODE_ENV === 'production') {
      this.uri = 'https://api.mycrogym.com/calendarrequest/'
    }
    let today = new Date()
    this.firstday = new Date()
    this.firstday.setHours(0,0,0)
    this.lastday = new Date()
    this.lastday.setDate(this.lastday.getDate() + 6)
    this.lastday.setHours(23,59,0)
  },
  mounted: function () {
    this.getdatafromserver()
    this.getdays()
  },
  methods: {
    gettimeformat (datetime) {
      return new Date(datetime).formatDate('HH:mm')
    },
    getservicedata: function (serviceid) {
      return this.companyservices.find(service => service.id === serviceid)
    },
    geteventsofday: function (day) {
      let datestring = new Date(day).formatDate('YYYY-MM-DD')
      let events = this.calendarevents.filter(event => datestring === new Date(event.datestart).formatDate('YYYY-MM-DD'))
      return events
    },
    geteventsoftimeslot: function (day, starttime, endtime) {
      let newdatestart = new Date(day)
      let newdateend = new Date(day)
      let starttimeobj = starttime.split(":")
      let endtimeobj = endtime.split(":")
      newdatestart.setHours(starttimeobj[0])
      newdatestart.setMinutes(starttimeobj[1])
      newdateend.setHours(endtimeobj[0])
      newdateend.setMinutes(endtimeobj[1])
      let events = this.calendarevents.filter(event => newdatestart <= new Date(event.datestart) && newdateend >= new Date(event.datestart) && event.archive === 0)
      events.sort(function (a,b) {
        return new Date(a.datestart) - new Date(b.datestart)
      })
      return events
    },
    isToday (day) {
      let result = false
      let today = new Date()
      let todaystring = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2)
      if (todaystring === day) result = true
      return result
    },
    getdays () {
      let newdate = this.firstday
      this.days.push(newdate.formatDate("YYYY-MM-DD"))
      for (let i = 0; i < 6; i++) {
        newdate.setDate(newdate.getDate() + 1)
        this.days.push(newdate.formatDate("YYYY-MM-DD"))
      }
      return false
    },
    getdatafromserver: function () {
      let today = new Date()
      let payload = {}
      payload.companyid = this.companyid
      payload.locations = this.definedlocations
      payload.services = this.services
      payload.firstday = this.firstday.formatDate("YYYY-MM-DD HH:mm:ss")
      payload.lastday = this.lastday.formatDate("YYYY-MM-DD HH:mm:ss")
      this.$http.post(this.uri, JSON.stringify(payload))
        .then(function (response) {
          let results = []
          let array = []
          array = JSON.parse(response.body)
          console.log(array)
          results = array.calendarevents
          if (this.definedlocations !== '') {
            let locationsarray = this.definedlocations.split(",")
            results = results.filter(event => locationsarray.includes(event.locationid))
          }
          if (this.definedservices !== '') {
            let servicesarray = this.definedservices.split(",")
            results = results.filter(event => servicesarray.includes(event.serviceid))
          }
          this.calendarevents = results
          this.companyservices = array.services
        }, function (reason) {

        })
    }
  }
}
</script>
